//REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";

//LOGIN
export const POST_JWT_LOGIN = "/auth/local";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";
export const POST_FORGET_PASSWORD = "/auth/forgot-password";
export const POST_RESET_PASSWORD = "/auth/reset-password";
export const POST_CHANGE_PASSWORD = "/auth/change-password";
export const POST_REGISTER = "/auth/local/register";

//Users
export const GET_USERS_DEFAULT = "/users";
export const GET_USERS = "/user-management/users";
export const GET_USER = "/user-management/users";
export const ADD_USER = "/user-management/users";
export const UPDATE_USER = "/user-management/users";
export const DELETE_USER = "/user-management/users";
export const ACTIVATE_USER = "/user-management/users/activate";
export const DEACTIVATE_USER = "/user-management/users/deactivate";
export const GET_USER_PROFILE = "/users/me";
export const UPDATE_MY_PROFILE = "/user-management/users/me";

export const GET_AGENCY_USERS = "/agency/user-management/users";
export const INVITE_USER = "/user-management/users/invite";

// Role
export const GET_ROLES = "/users-permissions/roles";
export const GET_ROLE = "/users-permissions/roles";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// MDAs
export const GET_MDAS = "/mdas";
export const GET_MDA = "/mdas";
export const ADD_MDA = "/mdas";
export const UPDATE_MDA = "/mdas";
export const DELETE_MDA = "/mdas";
export const EXPORT_MDAS_TO_CSV = "/mdas/export/csv";
export const IMPORT_MDA = "/mdas/import";
export const GET_MDA_AGENCIES = "/mdas";

// Payments
export const GET_PAYMENTS = "/payments";
export const GET_PAYMENT = "/payments";
export const ADD_PAYMENT = "/payments";
export const UPDATE_PAYMENT = "/payments";
export const DELETE_PAYMENT = "/payments";
export const DELETE_ALL_PAYMENTS = "/payments/clear-all";
export const IMPORT_PAYMENT = "/payments/import";
export const IMPORT_PAYMENT_UPDATE = "/payments/import/update";
export const EXPORT_PAYMENTS_TO_CSV = "/payments/export/csv";
export const GET_TOTAL_PAYMENTS_AMOUNT = "/payments/stats/total-amount";
export const GET_TOTAL_PAYMENTS_COUNT = "/payments/stats/total-count";
export const GET_PAYMENTS_AGENCY_COUNT = "/payments/stats/agency-count";
export const GET_PAYMENTS_MDA_COUNT = "/payments/stats/mda-count";
export const GET_PAYMENTS_PER_CATEGORY =
  "/payments/stats/payments-per-category";
export const GET_PAYMENTS_SALARY_ALIGNED_DISTRIBUTION =
  "/payments/stats/salary-aligned";
export const GET_PAYMENTS_REGION_CATEGORY_DISTRIBUTION =
  "/payments/stats/region-category-distribution";
export const GET_PAYMENTS_AGENCY_CATEGORY_DISTRIBUTION =
  "/payments/stats/agency-category-distribution";
export const GET_PAYMENTS_REGION_GENDER_DISTRIBUTION =
  "/payments/stats/region-gender-distribution";
export const GET_PAYMENTS_GENDER_CATEGORY_DISTRIBUTION =
  "/payments/stats/gender-category-distribution";
export const GET_PAYMENTS_GENDER_DISTRIBUTION =
  "/payments/stats/gender-distribution";
export const GET_PAYMENTS_THEMATIC_AREA_DISTRIBUTION =
  "/payments/stats/thematic-area-distribution";
export const GET_PAYMENT_TREND_BY_CATEGORY =
  "/payments/stats/payment-trend-by-category";

// Admin Overlapping Payments
export const GET_OVERLAPPING_PAYMENTS = "/overlapping-payments";
export const GET_OVERLAPPING_PAYMENT = "/overlapping-payments";
export const ADD_OVERLAPPING_PAYMENT = "/overlapping-payments";
export const UPDATE_OVERLAPPING_PAYMENT = "/overlapping-payments";
export const DELETE_OVERLAPPING_PAYMENT = "/overlapping-payments";
export const SYNC_OVERLAPPING_PAYMENTS = "/overlapping-payments/run";
export const START_OVERLAPPING_PAYMENTS_SYNC = "/overlapping-payments/sync";
export const OVERLAPPING_PAYMENTS_SYNC_STATUS = "/overlapping-payments/sync";
export const RESOLVE_OVERLAPPING_PAYMENTS = "/overlapping-payments/resolve";
// Suffixed with "/:id/merge" in the service.
export const MERGE_OVERLAPPING_PAYMENT = "/overlapping-payments";
export const EXPORT_OVERLAPPING_PAYMENTS_TO_CSV =
  "/overlapping-payments/export/csv";
export const GET_AGENCY_OVERLAPPING_PAYMENTS = "/overlapping-payments/agency";
export const GET_AGENCY_OVERLAPPING_PAYMENT = "/overlapping-payments/agency";
export const EXPORT_AGENCY_OVERLAPPING_PAYMENTS_TO_CSV =
  "/overlapping-payments/agency/export/csv";

// Agency Payments
export const GET_AGENCY_PAYMENTS = "/payments/agency";
export const GET_AGENCY_PAYMENT = "/payments/agency";
export const ADD_AGENCY_PAYMENT = "/payments/agency";
export const UPDATE_AGENCY_PAYMENT = "/payments/agency";
export const DELETE_AGENCY_PAYMENT = "/payments/agency";
export const EXPORT_AGENCY_PAYMENTS_TO_CSV = "/payments/agency/export/csv";

// Individuals
export const GET_INDIVIDUALS = "/individuals";
export const GET_INDIVIDUAL = "/individuals";
export const ADD_INDIVIDUAL = "/individuals";
export const UPDATE_INDIVIDUAL = "/individuals";
export const DELETE_INDIVIDUAL = "/individuals";
export const DELETE_ALL_INDIVIDUALS = "/individuals/clear-all";
export const IMPORT_INDIVIDUAL = "/individuals/import";
export const EXPORT_INDIVIDUALS_TO_CSV = "/individuals/export/csv";
export const GET_INDIVIDUAL_AGENCIES = "/individuals";

// Agency Individuals
export const GET_AGENCY_INDIVIDUALS = "/individuals/agency";
export const GET_AGENCY_INDIVIDUAL = "/individuals/agency";
export const ADD_AGENCY_INDIVIDUAL = "/individuals/agency";
export const UPDATE_AGENCY_INDIVIDUAL = "/individuals/agency";
export const DELETE_AGENCY_INDIVIDUAL = "/individuals/agency";
export const EXPORT_AGENCY_INDIVIDUALS_TO_CSV = "/individuals/agency/export/csv";

// Regions
export const GET_REGIONS = "/regions";
export const GET_REGION = "/regions";
export const ADD_REGION = "/regions";
export const UPDATE_REGION = "/regions";
export const DELETE_REGION = "/regions";

export const GET_COUNTRIES = "/countries";

// Agencies
export const GET_GLOBAL_AGENCIES = "/global-admin/agencies";
export const GET_AGENCIES = "/agencies";
export const GET_AGENCY = "/agencies";
export const ADD_AGENCY = "/agencies";
export const UPDATE_AGENCY = "/agencies";
export const DELETE_AGENCY = "/agencies";

// Position Types
export const GET_POSITION_TYPES = "/position-types";
export const GET_POSITION_TYPE = "/position-types";
export const ADD_POSITION_TYPE = "/position-types";
export const UPDATE_POSITION_TYPE = "/position-types";
export const DELETE_POSITION_TYPE = "/position-types";

// Payment Categories
export const GET_PAYMENT_CATEGORIES = "/payment-categories";
export const GET_PAYMENT_CATEGORY = "/payment-categories";
export const ADD_PAYMENT_CATEGORY = "/payment-categories";
export const UPDATE_PAYMENT_CATEGORY = "/payment-categories";
export const DELETE_PAYMENT_CATEGORY = "/payment-categories";

// Government Requests
export const GET_GOVT_REQUESTS = "/government-requests";
export const GET_GOVT_REQUEST = "/government-requests";
export const ADD_GOVT_REQUEST = "/government-requests";
export const UPDATE_GOVT_REQUEST = "/government-requests";
export const DELETE_GOVT_REQUEST = "/government-requests";
export const IMPORT_GOVT_REQUEST = "/government-requests/import";
export const EXPORT_GOVT_REQUESTS_TO_CSV = "/government-requests/export/csv";

// Agency Government Requests
export const GET_AGENCY_GOVT_REQUESTS = "/government-requests/agency";
export const GET_AGENCY_GOVT_REQUEST = "/government-requests/agency";
export const ADD_AGENCY_GOVT_REQUEST = "/government-requests/agency";
export const UPDATE_AGENCY_GOVT_REQUEST = "/government-requests/agency";
export const DELETE_AGENCY_GOVT_REQUEST = "/government-requests/agency";

// Public Government Requests
export const ADD_PUBLIC_GOVERNMENT_REQUEST = "/government-requests/public";

// Government Request Types
export const GET_REQUEST_TYPES = "/government-request-types";
export const GET_REQUEST_TYPE = "/government-request-types";
export const ADD_REQUEST_TYPE = "/government-request-types";
export const UPDATE_REQUEST_TYPE = "/government-request-types";
export const DELETE_REQUEST_TYPE = "/government-request-types";

// Government Form of Requests
export const GET_FORM_OF_REQUESTS = "/government-request-forms";
export const GET_FORM_OF_REQUEST = "/government-request-forms";
export const ADD_FORM_OF_REQUEST = "/government-request-forms";
export const UPDATE_FORM_OF_REQUEST = "/government-request-forms";
export const DELETE_FORM_OF_REQUEST = "/government-request-forms";

// LOAs
export const GET_LOAS = "/loas";
export const GET_LOA = "/loas";
export const ADD_LOA = "/loas";
export const UPDATE_LOA = "/loas";
export const DELETE_LOA = "/loas";
export const GET_LOA_SUMMARY = "/loas/summary";
export const EXPORT_LOA_TO_CSV = "/loas/export/csv";
export const IMPORT_LOA = "/loas/import";

// Thematic Area
export const GET_THEMATIC_AREAS = "/thematic-areas";
export const GET_THEMATIC_AREA = "/thematic-areas";
export const ADD_THEMATIC_AREA = "/thematic-areas";
export const UPDATE_THEMATIC_AREA = "/thematic-areas";
export const DELETE_THEMATIC_AREA = "/thematic-areas";

// Sector
export const GET_SECTORS = "/sectors";
export const GET_SECTOR = "/sectors";
export const ADD_SECTOR = "/sectors";
export const UPDATE_SECTOR = "/sectors";
export const DELETE_SECTOR = "/sectors";

// Search
export const DOWNLOAD_SEARCH_REPORT = "/search/report";
export const DOWNLOAD_BULK_SEARCH_TEMPLATE = "/search/bulk-search-template";
export const BULK_SEARCH = "/search/bulk-search";
export const BULK_SEARCH_PROGRESS = "/search/bulk-search/status";
export const SEARCH_GLOBAL_CONTENT = "/search";
